import { EventBus } from "../../services/event-bus";
import routeNames from "../../router/route-names";
const state = {
  instanceId: null,
  authToken: null,
};

const getters = {
  authStatus: (state) => state.authToken != null,
  authToken: (state) => state.authToken,
  instanceId: (state) => state.instanceId,
};

const actions = {
  logOut: ({ commit, state }, router) => {
    localStorage.removeItem(`api-key#${state.instanceId}`);
    commit("setAuthToken", null);
    EventBus.$emit("authChange", state.token);
    router.push({ name: routeNames.LOGIN });
  },
  logIn: ({ commit, state }, { router, token }) => {
    localStorage.setItem(`api-key#${state.instanceId}`, token);
    commit("setAuthToken", token);
    EventBus.$emit("authChange", state.token);
    router.push({ name: routeNames.WALLET });
  },
};

const mutations = {
  setAuthToken: (state, token) => {
    state.authToken = token;
  },
  setInstanceId: (state, instanceId) => {
    state.instanceId = instanceId;
    state.authToken = localStorage.getItem(`api-key#${state.instanceId}`);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
